export default __webpack_public_path__ + "static/media/promo-you-know-who_03.8b784457.jpg";